// extracted by mini-css-extract-plugin
export var container = "_z-0";
export var disabled = "_z-4";
export var fullWidth = "_z-3";
export var lined = "_z-1";
export var selected = "_z-5";
export var tab = "_z-2";